import { LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import React, { Fragment, useState } from 'react';

import styles from './index.module.scss';
const PreservationButton = (props) => {
  console.log(props, '==props');

  let color = '#69B49E';
  if (
    (props.item && props.item.value === '開啟') ||
    (props.item && typeof props.item.value === 'number' && props.item.value > 0)
  )
    color = '#4B4B4B';
  // function getTextUI(item) {
  //   if (item && item.value) {
  //     let text;
  //     if (item.value === '關閉') {
  //       text = '開啟';
  //     } else {
  //       text = '關閉';
  //     }
  //     const arr = text.split('\n').map((x) => <div>{x}</div>); // .join(<br />)
  //     return arr;
  //   } else {
  //     return <Fragment>無文字</Fragment>;
  //   }
  // }
  return (
    <div className={styles.BAButtonContainer}>
      {props.value === '關閉' ? (
        <>
          <img
            className={styles.BAButtonImg}
            src="icon/ic_home security_turn on.svg"
            alt="保全開啟icon"
          />
          <div className={styles.BAText}>保全解除</div>
        </>
      ) : (
        <>
          <img
            className={styles.BAButtonImg}
            src="icon/ic_home security_turn off.svg"
            alt="保全關閉icon"
          />
          <div className={styles.BAText}>保全啟動</div>
        </>
      )}
      <div
        className={styles.BAButton}
        style={{
          backgroundColor: props.value === '關閉' ? '#69B49E' : '#4B4B4B',
        }}
        onClick={() => {
          props.setShowMailOpen(true);
          console.log(props.value, '==props.value');
          const value = props.value === '關閉' ? '開啟' : '關閉';
          // console.log(value, '==value');
          const newObj = { ...props.item, value };
          axios('/ezcon/api/ba/setHouseSecurity', {
            method: 'POST',
            headers: { authorization: window.localStorage['feathers-jwt'] },
            data: newObj,
          });
        }}
      >
        <div className={styles.ItemText}>
          {props.value === '關閉' ? '設定保全' : '解除保全'}
        </div>
      </div>
      <div
        className={styles.showMailOpen}
        style={{ display: props.showMailOpen ? 'flex' : 'none' }}
      >
        <p className={styles.showMailText}>
          <LoadingOutlined />
        </p>
      </div>
    </div>
  );
};

export default PreservationButton;
